import React from "react";
import { ConfirmSvg } from "../../../svgFiles/confirmSvg";
import LogoImage from "../../../images/dried-mango-logo.svg";
import Form from "react-bootstrap/Form";
import Button from "../../../components/shared/buttons/button";
import ViewPassword from "../../../images/eye-icon.svg";
import "./createPassword.css";
import LanguageToggleSwitch from "../../../components/shared/LanguageToggleSwitch/LanguageToggleSwitch";
import useTranslator from "../../../hooks/useTranslator";
const CreatePassword = () => {
  const { _t } = useTranslator();
  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center light_bg">
      <div className="login_wrapper d-flex justify-content-center align-items-center create_password">
        <div className="login_form ">
          <img src={LogoImage} alt="logo" className="img-fluid" />
          <div className="d-flex align-items-center w-full justify-content-between">
            <h1>{_t("create_your_password", "Create Your Password")}</h1>
            <LanguageToggleSwitch />
          </div>
          <p className="pt-1">
            {_t("create_a_new_password", "Create a new password")}
          </p>
          <Form.Group className="mb-3 cmn_input">
            <Form.Label>{_t("create_password", "Create Password")}</Form.Label>
            <div className="position-relative">
              <Form.Control
                type="password"
                placeholder={_t("enter_new_password", "Enter new password")}
                autoComplete="new-password"
              />
              <span className="view_pass">
                <img src={ViewPassword} alt="eye" />
              </span>
            </div>
          </Form.Group>
          <Form.Group className="mb-4 cmn_input">
            <Form.Label>
              {_t("confirm_password", "Confirm Password")}
            </Form.Label>
            <div className="position-relative">
              <Form.Control
                type="password"
                placeholder={_t("confirm_password", "Confirm password")}
                autoComplete="new-password"
              />
              <span className="view_pass">
                <img src={ViewPassword} alt="eye" />
              </span>
            </div>
          </Form.Group>
          <Button
            label={_t("confirm", "Confirm")}
            size="medium"
            className="w-100"
          />
        </div>
        <div className="password_confirmed d-none">
          <div className="confirm_image text-center">{ConfirmSvg}</div>
          <h4>
            {_t(
              "password_created_success",
              "Tu contraseña ha sido creada con éxito"
            )}
            .
          </h4>
          <h3>
            {_t(
              "continue_to_login",
              "Continúa para iniciar sesión en tu cuenta"
            )}
            .
          </h3>
          <Button label="Continue" size="medium" className="w-100" />
        </div>
      </div>
    </div>
  );
};

export default CreatePassword;
